import React, { useState, useEffect } from "react";
import "./DashboardBalanceItem.scss";
import { decimalTo } from '../../../../utils/utils'

export default function DashboardBalanceItem(props) {
  const [htmltemplate, setHtmlTemplate] = useState([]);
  const { text, dashBalance, minimumBalance, dashStock } = props;

  useEffect(() => {
    let template = [];

    if (text === "Balance") {
      dashBalance.forEach((dt, index) => {
        const threshold = dt.creditAvalable < minimumBalance;
        const alertcolor = threshold ? "alert pink-alert" : "alert green-alert";
        const alertText = threshold ? "is running out of Balance." : "has topped the Balance.";
        
        template.push(
          <div key={`balance-${dt.usemerchentName}-${index}`} className={alertcolor}>
            {dt.usemerchentName} {alertText} The Current Balance is {decimalTo(dt.creditAvalable).toFixed(2)}
          </div>
        );
      });
    }

    if (text === "Stock") {
      dashStock.forEach((dt, index) => {
        const threshold = dt.stockAvailable < dt.threshold;
        const alertcolor = threshold ? "alert pink-alert" : "alert green-alert";
        const alertText = threshold ? "is running out of Stock." : "is having stock";
        
        template.push(
          <div key={`stock-${dt.productName}-${index}`} className={alertcolor}>
            {dt.productName} {alertText} The Current Stock is {dt.stockAvailable}
          </div>
        );
      });
    }

    if (template.length === 0) {
      template.push(
        <div key="no-data" className="alert info-alert">
          No Data Found
        </div>
      );
    }

    setHtmlTemplate(template);
  }, [dashBalance, dashStock, minimumBalance, text]);

  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-sm-2">
      <div className="card card-height">
        <div className="card-body">
          <h1 className="sec-header">{text}</h1>
          <div className="scrollable">
            {htmltemplate}
          </div>
        </div>
      </div>
    </div>
  );
}
